<script setup>
import { computed, defineAsyncComponent, defineProps } from 'vue'

const Grape = defineAsyncComponent(
  () => import('@/components/basic/atoms/Grape.vue')
)

const props = defineProps({
  text: String
})

const formattedValue = computed(() => {
  return props.text?.replace(/(\d+)\s*%/, '$1 %') ?? ''
})
</script>

<template>
  <div class="pa-2 position-relative d-flex align-center justify-center">
    <Grape
      color="primary"
      class="position-absolute top-0 bottom-0 left-0 right-0"
    />
    <span
      class="text-white text-no-wrap font-weight-bold font-size-m position-relative"
    >
      {{ formattedValue }}
    </span>
  </div>
</template>
